export default __webpack_public_path__ + "static/media/Open.6096f778.svg";